const Currency = `
  id
  code
  description
  name
`;

export default Currency;
